










































import { Component, Prop, Vue, Watch, PropSync } from "vue-property-decorator";
import _, { isNumber } from "lodash";
import { DxButton } from "devextreme-vue/ui/button";
import { DxPopup } from "devextreme-vue";
import DTextbox from "@/components/DTextbox/textbox.vue";
import { YearType } from "@/services/models-service";
import YearService from "@/services/years-service";



@Component({
  name: "YearPopup",
  components: {
    DxButton,
    DxPopup,
    DTextbox,
  }
})
export default class extends Vue {
@PropSync('popupOptions') public localPopupOptions: any;
@Prop() public all_years: YearType[];
private year: YearType = new YearType();
private number: string = "";
private isValid:boolean = true;



  async created() {


  }

  async mounted() {

  }

onShowing() {

}

validation() {

    this.year.name = Number(this.number);
    if(this.year.name && isNumber(this.year.name)) {

      this.isValid = true;
    } else {
        this.isValid = false;
    }
}

async onSave() {
    this.validation();
    if(this.isValid) {
       await YearService.save(this.year);
       await YearService.updateFromDb();
       this.$emit("change_year");
       this.onClose();
    }
}

onClose() {
    this.localPopupOptions.visible = false;
}


}
